import React, { useState, useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import HomePage from "./components/HomePage";
import Dashboard from "./components/dash";
import Intro from "./components/IntroScreen";
import InvestmentsPage from "./components/opportunities";
import Terms from "./components/terms";
import Feed from "./components/feed";
import AboutPage from "./components/aboutextra";

function AppRoutes() {
  const [showIntro, setShowIntro] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (showIntro) {
      const timer = setTimeout(() => {
        setShowIntro(false);
        navigate("/");
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [showIntro, navigate]);

  if (showIntro) return <Intro />;

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/dash" element={<Dashboard />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/inv" element={<InvestmentsPage/>}/>
      <Route path="/terms" element={<Terms/>}/>
      <Route path="/Feed" element={<Feed/>}/>
    </Routes>
  );
}

function App() {
  return (
    
      <AppRoutes />
   
  );
}

export default App;
